import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from '@environments/environment';

if (environment.production) {
    enableProdMode();
}

(function() {

    const loadAngular = (window as any).LOAD_ANGULAR;
    const isModern = (window as any).APP_CONFIG ? (window as any).APP_CONFIG.isModernBrowser : false;

    /**
     * Если браузер не современный, то и грузить приложение не будем.
     * Грузить не будем так же, если на этой странице не нужен Angular
     * Определяется современность браузера в самом первом выполняемом скрипте
     */
    if (!loadAngular || !isModern) {
        return;
    }

    const loader = document.getElementById('page-loader');

    try {
        platformBrowserDynamic()
            .bootstrapModule(AppModule)
            .then(() => {
                /**
                 * После загрузки приложения скрываем прелоадер страницы
                 * @type {HTMLElement}
                 */
                hideLoader();
            })
            .catch(error => {
                console.log(error);
            });
    } catch (e) {
        console.error(e);
        const message = document.getElementById('preload-message');
        message.innerHTML = 'Возникла ошибка во время запуска приложения, обратитесь в техническую поддержку.';
    }


    function hideLoader() {
        if (!loader) {
            return;
        }

        const fadeDuration = 1000;

        loader.style.transition = `opacity ${fadeDuration}ms`;
        loader.style.opacity = '0';

        setTimeout(() => {
            loader.parentElement.removeChild(loader);
        }, fadeDuration);
    }
})();

